import { Component, Input } from "@angular/core";
import {
  Invite,
  User,
  InviteListConfig,
} from "../../../../../../../shared/models";

@Component({
  selector: "invite-notification-preview",
  templateUrl: "./invite-notification-preview.component.html",
  styleUrls: [
    "./invite-notification-preview.component.scss",
    "../../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class InviteNotificationPreviewComponent {
  private defaultUserImg: string =
    "../../../../../../../../assets/images/uMuzi/african-mask.png";

  @Input() config: InviteListConfig;
  @Input() currentUser: User;
  @Input() invite: Invite;

  constructor() {}

  ngOnInit() {}
}
